var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarCell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 520.1 507.6",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_54"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m442.5 298.6h19.8v182.6h-19.8z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463 507.6h-406.6v-8.8c0-9.7 7.9-17.6 17.6-17.6h389z",
    fill: "#b6b9ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.3 252.5v29.8c0 10.4 6 19.8 15.3 24.4 8.5 4.2 18.5 3.7 26.5-1.4 7.9-5 12.6-13.7 12.6-23v-136l-17.9 34.9-21.2 41.4z",
    fill: "#b6b9ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 436.4 25 24h259.5l106.5-207.9 54.4-106.2 38.6-75.4-.2-51.3-61.6 121-31.2 61.2-119.5 234.6z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.3 436.4h271.5l212.3-416.8h-271.5z",
    fill: "#3f8fd5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.2 430.4h49l53.3-104.8h-48.9z",
    fill: "#2d7cad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.7 430.4h56.4l53.3-104.8h-56.3z",
    fill: "#2d7cad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.6 313.6h55.1l42.8-84h-55.1z",
    fill: "#2d7cad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.2 313.6h56.3l42.8-84h-56.3z",
    fill: "#2d7cad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.9 109.6h57.2l42.8-84h-57.2z",
    fill: "#2d7cad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.9 217.6h57.2l48.9-96h-57.2z",
    fill: "#2d7cad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.5 109.6h55.1l42.8-84h-55.1z",
    fill: "#2d7cad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.2 16.5c-1-1.8-3-2.9-5.1-2.9h-271.5c-2.3 0-4.3 1.3-5.4 3.3l-212.2 416.8c-1 1.9-.9 4.1.2 5.9 1.1 1.7 3 2.8 5.1 2.8h271.5c2.3 0 4.3-1.2 5.4-3.2l212.3-416.8c.9-1.9.8-4.1-.3-5.9zm-112.7 201.1h-48.9l48.9-96h48.9zm-48.9 96h-48.9l42.8-84h48.9zm-179.1 116.8 53.4-104.8h57.2l-53.4 104.8zm-69.8 0 53.4-104.8h56.3l-53.4 104.8zm33.7-200.8h55.1l-42.8 84h-55.1zm55-108h55.1l-48.9 96h-55.1zm173.8-96-42.8 84h-56.3l42.8-84zm-48.9 96-48.9 96h-56.3l48.9-96zm-111.3 108h56.3l-42.8 84h-56.3zm27 84 42.8-84h57.2l-42.8 84zm106.1-96h-57.2l48.9-96h57.2zm-2.2-108 42.8-84h57.2l-42.8 84zm-95.6-84h55.1l-42.8 84h-55.1zm-152.8 300h55.1l-53.4 104.8h-55.1zm204.7 104.8h-49l53.4-104.8h48.9zm163.4-320.8h-49l42.8-84h48.9z",
    fill: "#2670a8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.7,
    cy: 95.4,
    fill: "#e59b23",
    r: 46.8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e58423"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.5 95.4c0 25.8-21 46.8-46.8 46.8-15.1 0-29.2-7.3-38-19.5 30.9-5.8 53.8-27.4 53.8-53.1 0-6.9-1.7-13.6-4.8-19.7 21 5 35.8 23.9 35.8 45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159 84.7h22.3v12h-22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 84.7h22.3v12h-22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.1.1h12v22.3h-12z",
    transform: "matrix(1 -.007 .007 1 -.076 .629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.2 159.1h12v22.3h-12z",
    transform: "matrix(1 -.007 .007 1 -1.186 .641)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.7 28.6h22.3v12h-22.3z",
    transform: "matrix(.707 -.707 .707 .707 18.572 113.949)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.3 140.9h22.3v12h-22.3z",
    transform: "matrix(.707 -.707 .707 .707 -93.799 67.379)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.1 23.9h12v22.3h-12z",
    transform: "matrix(.702 -.712 .712 .702 -14.805 34.699)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.3 135.5h12v22.3h-12z",
    transform: "matrix(.702 -.712 .712 .702 -60.55 148.577)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarCell);
export default __webpack_public_path__ + "static/media/solar-cell.a4338a3d6d7b64ee30b740181f349792.svg";
export { ForwardRef as ReactComponent };